// extracted by mini-css-extract-plugin
var _1 = "KeyBindTag_active__990af";
var _2 = "KeyBindTag_dark__c1b71";
var _3 = "KeyBindTag_part__b71a9";
var _4 = "KeyBindTag_root__bf3c9";
export { _1 as "active", _2 as "dark", _3 as "part", _4 as "root" }
